// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
import type PeopleIcons from './PeopleIcons';

export type PeopleIconsSubset = { [icon in PeopleIcons]: string };

export let PeopleIconsDefinitions: PeopleIconsSubset = {
    AddFavorite: '\uf0c8',
    ChevronDownSmall: '\ue96e',
    ContactInfo: '\ue779',
    ContactLink: '\uf25f',
    Export: '\uede1',
    FabricNetworkFolder: '\uf5e6',
    FabricUserFolder: '\uf5e5',
    Import: '\ue8b5',
    Leave: '\uf627',
    PeopleRepeat: '\ued92',
    PlayerSettings: '\uef58',
    RecruitmentManagement: '\uee12',
    ReminderGroup: '\uebf8',
    RevToggleKey: '\ue845',
    SignOut: '\uf3b1',
    Subscribe: '\ueda1',
    Sync: '\ue895',
    Unfavorite: '\ue8d9',
    Unsubscribe: '\ueda0',
    UserRemove: '\uf69b',
};

export default {
    fontFileName: 'peopleIcons',
    icons: PeopleIconsDefinitions,
};
